import { useTranslation } from 'react-i18next';
import './Legislation.css'

const PrivacyLegislation = () => {
  const { t } = useTranslation()
  const sections = [
    {
      title: t("privacy-policy:section-1.title","Introduction"),
      paragraphs: [t("privacy-policy:section-1.body","This Privacy Policy describes how Corridor 10 collects, uses, and protects personal data of users who access and use the platform.")]
    },
    {
      title: t("privacy-policy:section-2.title","Information We Collect"),
      intro: t("privacy-policy:section-2.intro","We may collect the following types of information:"),
      list: [
        t("privacy-policy:section-2.item-1","Personal information (such as name, email address, phone number)"),
        t("privacy-policy:section-2.item-2","Company information"),
        t("privacy-policy:section-2.item-3","Account and login details"),
        t("privacy-policy:section-2.item-4","Shipment and transport-related information"),
        t("privacy-policy:section-2.item-5","Technical data (such as IP address, browser type, and usage data)")
      ]
    },
    {
      title: t("privacy-policy:section-3.title","How We Use Your Information"),
      intro: t("privacy-policy:section-3.intro","Your information is used to:"),
      list: [
        t("privacy-policy:section-3.item-1","Provide and manage the platform's services"),
        t("privacy-policy:section-3.item-2","Organize and process transportation requests"),
        t("privacy-policy:section-3.item-3","Communicate with users regarding their accounts or shipments"),
        t("privacy-policy:section-3.item-4","Improve platform functionality and user experience"),
        t("privacy-policy:section-3.item-5","Comply with legal and regulatory obligations")
      ]
    },
    {
      title: t("privacy-policy:section-4.title","Data Sharing"),
      intro: t("privacy-policy:section-4.intro","We may share your data only with:"),
      list: [
        t("privacy-policy:section-4.item-1","Carriers and logistics partners involved in the transportation process"),
        t("privacy-policy:section-4.item-2","Service providers supporting platform operations"),
        t("privacy-policy:section-4.item-3","Authorities, if required by law"),
        t("privacy-policy:section-4.item-4","We do not sell or rent personal data to third parties.")
      ],
      // paragraphs: [t("privacy-policy:section-4.body")]
    },
    {
      title: t("privacy-policy:section-5.title","Data Security"),
      paragraphs: [t("privacy-policy:section-5.body","We implement appropriate technical and organizational measures to protect your data against unauthorized access, loss, or misuse.")]
    },
    {
      title: t("privacy-policy:section-6.title","Data Retention"),
      paragraphs: [t("privacy-policy:section-6.body","Personal data is retained only for as long as necessary to fulfill the purposes outlined in this policy or as required by law.")]
    },
    {
      title: t("privacy-policy:section-7.title","User Rights"),
      intro: t("privacy-policy:section-7.intro","Depending on applicable laws, users may have the right to:"),
      list: [
        t("privacy-policy:section-7.item-1","Access their personal data"),
        t("privacy-policy:section-7.item-2","Request correction or deletion of data"),
        t("privacy-policy:section-7.item-3","Restrict or object to data processing"),
        t("privacy-policy:section-7.item-4","Request data portability")
      ]
    },
    {
      title: t("privacy-policy:section-8.title","Cookies"),
      paragraphs: [t("privacy-policy:section-8.body","The platform may use cookies and similar technologies to ensure proper functionality and improve user experience.")]
    },
    {
      title: t("privacy-policy:section-9.title","Changes to This Privacy Policy"),
      paragraphs: [t("privacy-policy:section-9.body","We may update this Privacy Policy from time to time. Any changes will be published on the platform.")]
    },
    {
      title: t("privacy-policy:section-10.title","Contact"),
      paragraphs: [t("privacy-policy:section-10.body","If you have questions regarding this Privacy Policy or your personal data, you may contact us through the platform's official communication channels.")]
    }
  ];

  return (
    <>
      <div className="details-overlay overlay-1">
        <p className="title-text">
          {t("landing:footer.privacy","Privacy Policy")}
        </p>
      </div>
      <div className="min-h-screen bg-gradient-to-b to-white p-8 legislation-page-wrap">
        <div className="mx-auto legislation-content-wrap">
          <div className="mt-3">
            <div className="custom-accordion-item p-4">
              <p className="fs-16 mb-4">
                <strong>{t("privacy-policy:effective-date-title","Effective Date:")}</strong> {t("privacy-policy:effective-date","01.01.2026")}
              </p>

              {sections.map((section, index) => (
                <div key={section.title} className="mb-4">
                  <h5 className="mb-2">{`${index + 1}. ${section.title}`}</h5>
                  {section.intro ? <p className="fs-16 mb-2">{section.intro}</p> : null}
                  {section.paragraphs?.map((paragraph) => (
                    <p key={paragraph} className="fs-16 mb-2">{paragraph}</p>
                  ))}
                  {section.list ? (
                    <ul className="list-disc ml-6">
                      {section.list.map((item) => (
                        <li key={item} className="fs-16 mb-1">{item}</li>
                      ))}
                    </ul>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyLegislation;